var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('header',[_c('TopNavi',{attrs:{"profile_name":this.$store.getters.profileGetName}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }